import * as Yup from "yup";
import { FormattedMessage } from "react-intl";
import { ZIP_CODE_LENGTH } from "../constants";

const amountSchema = Yup.number()
  .test(
    "decimals",
    () => <FormattedMessage id="validations.maxDecimals" />,
    (val) => {
      return val ? val.toString().match(/^[0-9]*(?:\.[0-9]{0,2})?$/) : true;
    }
  )
  .min(0.01, () => <FormattedMessage id="validations.minZero" />)
  .typeError(() => <FormattedMessage id="common.fieldMustBeANumber" />);

const validations = {
  amount: amountSchema,
  amountWithMin: amountSchema.min(1, () => (
    <FormattedMessage id="validations.minOne" />
  )),
  password: Yup.string().min(8, () => (
    <FormattedMessage id="account.security.minPasswordLength" />
  )),
  zipCode: Yup.string()
    .matches(/^\d+$/, () => <FormattedMessage id="common.fieldMustBeANumber" />)
    .length(ZIP_CODE_LENGTH, () => (
      <FormattedMessage
        id="common.fieldLengthMustBeExactly"
        values={{
          length: ZIP_CODE_LENGTH,
        }}
      />
    )),
  phone: Yup.string().matches(/^\d+$/, () => (
    <FormattedMessage id="common.fieldMustBeANumber" />
  )),
  email: Yup.string().email(() => <FormattedMessage id="common.validEmail" />),
};

export default validations;
